import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { createPortal } from "react-dom";
import "react-toastify/dist/ReactToastify.css";
import Calendario from "../components/Calendario";
import InterventoModal from "../components/InterventoModal";
import Materiali from "../components/Materiali";
import Preventivi from "./Preventivi";
import { FaTasks, FaCheckCircle, FaPlus, FaTrash, FaEdit, FaEye, FaFileAlt, FaTools, FaUsers, FaMoneyBillWave, FaDownload, FaFilePdf, FaBars, FaTruck, FaBell, FaHome, FaChartBar, FaBrain, FaCalendarAlt } from "react-icons/fa";import "../styles/Dashboard.css";
import ProtectedRoute from "../components/ProtectedRoute";
import Clienti from "../components/Clienti";
import ClienteModal from "../components/ClienteModal";
import '../styles/Dashboard.css';
import debounce from "lodash.debounce";
import InterventoForm from "../components/InterventoForm";
import { clearInterventoDraftAliases } from "../services/interventoDraftStorage";
import MediaPreview from "../components/MediaPreview";
import TabellaInterventi from "../components/TabellaInterventi";
import {
  getFlottaDestination,
  setFlottaDestination,
} from "../services/flottaApi";
import TabellaPreventivi from "../components/TabellaPreventivi";
import PreventivoModal from "../components/PreventivoModal";
import Flotta from "../components/Flotta";
import InboxRichieste from "../components/InboxRichieste/InboxRichieste";
import HomeOperativa from "../components/HomeOperativa/HomeOperativa";
import AnalisiDashboard from "../components/Analisi/AnalisiDashboard";
import CervelloBetaLumina from "../components/Cervello/CervelloBetaLumina";


import PushNotificationControl from "../components/PushNotificationControl";
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";
const WS_BASE_URL = process.env.REACT_APP_WS_URL || "wss://interventi.synology.me:5050";


const refreshToken = async () => {
  try {
    const oldToken = localStorage.getItem("token");
    if (!oldToken) {
      throw new Error("Nessun token disponibile");
    }
    const response = await axios.post(`${API_BASE_URL}/refresh-token`, {}, {
      headers: { Authorization: `Bearer ${oldToken}` },
      withCredentials: true,
    });
    const newToken = response.data.token;
    localStorage.setItem("token", newToken);
    console.log("âœ… Token rinnovato con successo");
    return newToken;
  } catch (error) {
    console.error("âŒ Errore nel refresh del token:", error);
    localStorage.removeItem("token");
    toast.error("Sessione scaduta. Effettua nuovamente il login.");
    window.location.href = "/";
    throw error;
  }
};

// Modifica l'intercettatore Axios per provare il refresh
// Interceptor Axios con protezione anti-loop
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const requestUrl = String(error?.config?.url || "");

    if (status === 401) {
      // NON fare refresh token sulle chiamate Google: evita loop infinito.
      if (
        requestUrl.includes("/google-calendar/") ||
        requestUrl.includes("/google-auth/")
      ) {
        console.warn("âš ï¸ Google Calendar 401: richiesta bloccata per evitare loop.");
        return Promise.reject(error);
      }

      // Evita retry infiniti sulla stessa richiesta
      if (error.config?._retry) {
        return Promise.reject(error);
      }

      error.config._retry = true;

      console.warn("âš ï¸ Token scaduto, tento il refresh una sola volta...");
      try {
        const newToken = await refreshToken();
        error.config.headers = error.config.headers || {};
        error.config.headers["Authorization"] = `Bearer ${newToken}`;
        return axios(error.config);
      } catch (refreshError) {
        return Promise.reject(refreshError);
      }
    }

    if (status === 403) {
      console.error("âŒ Accesso negato:", error.response?.data);
      toast.error("Accesso negato. Effettua nuovamente il login.");
      localStorage.removeItem("token");
      window.location.href = "/";
    }

    return Promise.reject(error);
  }
);


// Funzione per normalizzare la data
const normalizeDateForInput = (dateString) => {
  const date = new Date(dateString);
  const offset = date.getTimezoneOffset();
  const adjustedDate = new Date(date.getTime() - offset * 60 * 1000);
  return adjustedDate.toISOString().split("T")[0];
};


/* BETALUMINA_TOAST_PORTAL_BODY_FIX23C_20261019
   Il ToastContainer viene renderizzato tramite portal direttamente in document.body,
   così non resta intrappolato nello stacking context della Dashboard/modali. */
const GlobalToastContainer = (props) =>
  createPortal(<GlobalToastContainer {...props} />, document.body);

const Dashboard = () => {
  const [interventi, setInterventi] = useState([]);
  const [interventiChiusi, setInterventiChiusi] = useState([]);
  const [interventiDaClassificare, setInterventiDaClassificare] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [preventivi, setPreventivi] = useState([]);
  const [isPreventivoModalOpen, setIsPreventivoModalOpen] = useState(false);
  const [selectedPreventivo, setSelectedPreventivo] = useState(null);
  const [preventivoModalMode, setPreventivoModalMode] = useState("create");

  const { id: idFromParams } = useParams();
  const location = useLocation();
  const idFromState = location.state?.idIntervento || null;
  const idIntervento = idFromParams && idFromParams !== "undefined" ? idFromParams : idFromState;

  const [materialeDaModificare, setMaterialeDaModificare] = useState(null);
  const [cliente, setCliente] = useState("");
  const [clienteId, setClienteId] = useState(null);
  const [sitoClientePortaleId, setSitoClientePortaleId] = useState("");
  
  const [indirizzo, setIndirizzo] = useState("");
  const [oraInizio, setOraInizio] = useState("");
  const [oraFine, setOraFine] = useState("");
  const [stato, setStato] = useState("Da fare");
  const [modificaId, setModificaId] = useState(null);
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [piva, setPiva] = useState("");
  const [causale, setCausale] = useState("");
  const [descrizione, setDescrizione] = useState("");
  const [tipoIntervento, setTipoIntervento] = useState({
    garanzia: false,
    manutenzione: false,
    pagamento: false,
    installazione: false,
    ultimare: false,
  });
  const [codiceMateriale, setCodiceMateriale] = useState("");
  const [descrizioneMateriale, setDescrizioneMateriale] = useState("");
  const [quantitaMateriale, setQuantitaMateriale] = useState("");
  const [prezzoUnitario, setPrezzoUnitario] = useState("");
  const [materialeCatalogoId, setMaterialeCatalogoId] = useState(null);
  const [materialiCatalogo, setMaterialiCatalogo] = useState([]);
  const [loadingMaterialiCatalogo, setLoadingMaterialiCatalogo] = useState(false);
  const [totale, setTotale] = useState("");
  const [lavoriEseguiti, setLavoriEseguiti] = useState("");
  const [tecnico, setTecnico] = useState("");
  const [data, setData] = useState("");
  const [kmPercorsi, setKmPercorsi] = useState("");
  const [tempoPercorrenza, setTempoPercorrenza] = useState("");
  const [trasferta, setTrasferta] = useState("");
  // BETALUMINA_INTERVENTI_TRASFERTA_DETTAGLIO_R1
  const emptyCostiTrasfertaDettaglio = () => ({
    tariffaKm: "", oreViaggio: "", tariffaViaggio: "", pedaggi: "", parcheggi: "",
    spedizioni: "", noleggi: "", smaltimento: "", consumo: "", altroDescrizione: "", altroImporto: "",
  });
  const parseCostiTrasfertaDettaglio = (raw) => {
    try {
      const parsed = typeof raw === "string" && raw.trim() ? JSON.parse(raw) : (raw || {});
      return { ...emptyCostiTrasfertaDettaglio(), ...(parsed || {}) };
    } catch (_) { return emptyCostiTrasfertaDettaglio(); }
  };
  const [costiTrasfertaDettaglio, setCostiTrasfertaDettaglio] = useState(emptyCostiTrasfertaDettaglio());
  const [pagato, setPagato] = useState(false);
  const [metodoPagamento, setMetodoPagamento] = useState("");
  const [minutiPausa, setMinutiPausa] = useState(0);
  const [pausaInizio, setPausaInizio] = useState(null);
  const [materiali, setMateriali] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [extraMediaFiles, setExtraMediaFiles] = useState([]);
  const [extraMediaPreviews, setExtraMediaPreviews] = useState([]);
  const [selectedIntervento, setSelectedIntervento] = useState(null);
  const [mediaItems, setMediaItems] = useState([]);
  const [modalMode, setModalMode] = useState("create");
  // === BETALUMINA NAVIGATION PERSISTENCE V1 - 2026-08-30 ===
  const [activeTab, setActiveTab] = useState(() => {
    const stored = String(
      sessionStorage.getItem(
        "betalumina:dashboard:active-tab:v1"
      ) || ""
    ).trim();

    const allowed = [
      "home",
      "daClassificare",
      "attivita",
      "chiusi",
      "preventivi",
      "materiali",
      "clienti",
      "flotta",
      "analisi",
      "cervello",
    ];

    return allowed.includes(stored)
      ? stored
      : "home";
  });

  useEffect(() => {
    sessionStorage.setItem(
      "betalumina:dashboard:active-tab:v1",
      activeTab
    );
  }, [activeTab]);
  // === END BETALUMINA NAVIGATION PERSISTENCE V1 ===
  const [
    flottaInterventoId,
    setFlottaInterventoId,
  ] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [numeroFoglioIntervento, setNumeroFoglioIntervento] = useState("");

  const isClassificazione =
    modalMode === "edit" &&
    selectedIntervento?.stato === "Da classificare";

  // === EMAIL CLASSIFICAZIONE INTELLIGENTE V1 - PREFILL SOLO UI ===
  useEffect(() => {
    if (!isClassificazione || !selectedIntervento?.email_uid) return;
    const proposal = selectedIntervento?._emailClassificationProposal;
    if (!proposal) return;

    // Il mittente-staging NON viene promosso a cliente se il matching non e sicuro.
    setCliente(proposal.cliente || "");
    setIndirizzo(proposal.indirizzo || "");
    setTelefono(proposal.telefono || "");
    setEmail(proposal.email || "");
    setCausale(proposal.causale || "");
    setDescrizione(proposal.descrizione || "");
    setLavoriEseguiti("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClassificazione, selectedIntervento]);


  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [lastPos, setLastPos] = useState({ x: 0, y: 0 });

  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => {
      console.log("ðŸ“Œ Toggle sidebar:", !prev ? "aperta" : "chiusa");
      return !prev;
    });
  };

  useEffect(() => {
    fetchInterventi();
    fetchPreventivi();
    fetchClienti();
  
    let ws;
    const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minuti in millisecondi
    let inactivityTimer;
    let reconnectAttempts = 0;
    const maxReconnectAttempts = 10;
    const baseReconnectInterval = 1000; // 1 secondo
    const maxReconnectInterval = 30000; // 30 secondi
  
    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(() => {
        console.log("â° InattivitÃ  rilevata, logout...");
        localStorage.removeItem("token");
        toast.info("Sessione scaduta per inattività.");
        navigate("/");
      }, INACTIVITY_TIMEOUT);
    };
  
    const handleActivity = () => {
      resetInactivityTimer();
    };
  
    window.addEventListener("mousemove", handleActivity);
    window.addEventListener("keydown", handleActivity);
    window.addEventListener("touchstart", handleActivity);
  
    resetInactivityTimer();
  
    const connectWebSocket = () => {
      ws = new WebSocket(WS_BASE_URL);
      console.log("ðŸ“¡ Tentativo connessione WebSocket:", WS_BASE_URL);
  
      ws.onopen = () => {
        console.log("âœ… WebSocket connesso a:", WS_BASE_URL);
        reconnectAttempts = 0;
        const heartbeat = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: "ping" }));
            console.log("ðŸ“ Ping inviato");
          }
        }, 30000);
        ws.onclose = () => clearInterval(heartbeat);
      };
  
      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === "new_intervento") {
            const interventoNormalizzato = {
              ...data.intervento,
              indirizzo: data.intervento.indirizzo ?? "", // Normalizza indirizzo
            };
            setInterventi((prev) => {
              if (prev.some((i) => i.id === interventoNormalizzato.id)) {
                return prev;
              }
              console.log("ðŸ“§ Nuovo intervento normalizzato:", interventoNormalizzato);
              return [...prev, interventoNormalizzato];
            });
            toast.info(`Nuovo intervento da: ${interventoNormalizzato.cliente}`);
          } else if (data.type === "pong") {
            console.log("ðŸ“ Heartbeat ricevuto");
          }
        } catch (error) {
          console.error("âŒ Errore parsing messaggio WebSocket:", error);
        }
      };
  
      ws.onerror = (error) => {
        console.error("âŒ Errore WebSocket:", {
          message: error.message || "Errore sconosciuto",
          readyState: ws.readyState,
          url: WS_BASE_URL,
        });
      };
  
      ws.onclose = (event) => {
        console.log("ðŸ”Œ WebSocket chiuso:", {
          code: event.code,
          reason: event.reason || "Nessun motivo specificato",
          wasClean: event.wasClean,
        });
  
        if (reconnectAttempts < maxReconnectAttempts) {
          const delay = Math.min(
            baseReconnectInterval * Math.pow(2, reconnectAttempts),
            maxReconnectInterval
          );
          console.log(`â³ Riconnessione tra ${delay}ms (tentativo ${reconnectAttempts + 1})`);
          setTimeout(() => {
            reconnectAttempts++;
            connectWebSocket();
          }, delay);
        } else {
          console.error("ðŸš« Limite di riconnessioni raggiunto, abbandono.");
          toast.error("Connessione WebSocket persa. Controlla la rete o il server.");
        }
      };
    };
  
    connectWebSocket(); // Sposta questa riga qui, prima del cleanup
  
    return () => {
      console.log("ðŸ§¹ Cleanup WebSocket");
      if (ws && ws.readyState !== WebSocket.CLOSED && ws.readyState !== WebSocket.CLOSING) {
        ws.close(1000, "Componente smontato");
      }
      clearTimeout(inactivityTimer);
      window.removeEventListener("mousemove", handleActivity);
      window.removeEventListener("keydown", handleActivity);
      window.removeEventListener("touchstart", handleActivity);
    };
  }, [navigate]);

  const resetForm = () => {
    setCliente("");
    setIndirizzo("");
    setOraInizio("");
    setOraFine("");
    setStato("Da fare");
    setModificaId(null);
    setTelefono("");
    setEmail("");
    setPiva("");
    setCausale("");
    setDescrizione("");
    setTipoIntervento({
      garanzia: false,
      manutenzione: false,
      pagamento: false,
      installazione: false,
      ultimare: false,
    });
    setCodiceMateriale("");
    setQuantitaMateriale("");
    setPrezzoUnitario("");
    setTotale("");
    setLavoriEseguiti("");
    setTecnico("");
    setData("");
    setKmPercorsi("");
    setTempoPercorrenza("");
    setTrasferta("");
    setCostiTrasfertaDettaglio(emptyCostiTrasfertaDettaglio());
    setPagato(false);
    setMetodoPagamento("");
    setSelectedFiles([]);
    setPreviewFiles([]);
    setExtraMediaFiles([]);
    setExtraMediaPreviews([]);
    setMateriali([]);
    setNumeroFoglioIntervento("");
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (idIntervento && idIntervento !== "undefined" && idIntervento !== "null") {
      console.log("âœ… ID valido, chiamo fetchMateriali con ID:", idIntervento);
      fetchMateriali(idIntervento);
    } else {
      console.warn("âš ï¸ Attenzione: `idIntervento` Ã¨ undefined o null, `fetchMateriali` non viene chiamato.");
      setMateriali([]);
    }
  }, [idIntervento]);

  const fetchMateriali = async (idIntervento) => {
    if (!idIntervento) {
      toast.error("Errore: ID Intervento non valido!");
      console.error("âŒ ID Intervento non valido:", idIntervento);
      setMateriali([]);
      return;
    }

    try {
      console.log("ðŸ“¡ Fetching materiali per ID intervento:", idIntervento);
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/interventi/${idIntervento}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      if (!response.data || !response.data.materiali) {
        console.warn(`âš ï¸ Nessun materiale trovato per ID ${idIntervento}`);
        setMateriali([]);
        return;
      }

      setMateriali(response.data.materiali);
      console.log("âœ… Materiali ricevuti:", response.data.materiali);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.warn(`âš ï¸ Nessun materiale trovato per ID ${idIntervento} (404)`);
        setMateriali([]);
      } else {
        console.error("âŒ Errore nel recupero dei materiali:", error);
        toast.error("Errore nel recupero dei materiali!");
      }
    }
  };

  const fetchMaterialiCatalogo = async (search = "") => {
    setLoadingMaterialiCatalogo(true);

    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        `${API_BASE_URL}/materiali`,
        {
          params: search ? { search } : {},
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      const catalogo = Array.isArray(response.data)
        ? response.data
        : [];

      setMaterialiCatalogo(catalogo);

      return catalogo;
    } catch (error) {
      console.error(
        "Errore recupero catalogo materiali:",
        error
      );

      setMaterialiCatalogo([]);

      toast.error(
        "Errore nel recupero del catalogo materiali"
      );

      return [];
    } finally {
      setLoadingMaterialiCatalogo(false);
    }
  };

  const handleSelectMaterialeCatalogo = (materialeId) => {
    const id = Number.parseInt(materialeId, 10);

    if (!Number.isInteger(id) || id <= 0) {
      setMaterialeCatalogoId(null);
      return;
    }

    const materiale = materialiCatalogo.find(
      (item) => Number(item.id) === id
    );

    if (!materiale) {
      setMaterialeCatalogoId(null);
      return;
    }

    setMaterialeCatalogoId(materiale.id);

    setCodiceMateriale(
      materiale.codiceMateriale || ""
    );

    setDescrizioneMateriale(
      materiale.descrizioneMateriale || ""
    );

    setPrezzoUnitario(
      materiale.prezzoSenzaIva !== null &&
      materiale.prezzoSenzaIva !== undefined
        ? String(materiale.prezzoSenzaIva)
        : ""
    );

    setQuantitaMateriale((prev) =>
      prev === "" || prev === null || prev === undefined
        ? "1"
        : prev
    );
  };

  const fetchFlottaDestination = async () => {
    try {
      const result =
        await getFlottaDestination();

      setFlottaInterventoId(
        result?.intervention?.id || null
      );
    } catch (error) {
      console.error(
        "Errore caricamento destinazione Flotta:",
        error
      );

      setFlottaInterventoId(null);
    }
  };

  const handleImpostaFlotta = async (
    intervento
  ) => {
    if (!intervento?.id) {
      toast.error("Intervento non valido.");
      return;
    }

    const giaInFlotta =
      Number(flottaInterventoId) ===
      Number(intervento.id);

    try {
      if (giaInFlotta) {
        const token =
          localStorage.getItem("token");

        await axios.delete(
          `${API_BASE_URL}/api/flotta/destinazione`,
          {
            headers: token
              ? {
                  Authorization:
                    `Bearer ${token}`,
                }
              : {},
            withCredentials: true,
          }
        );

        setFlottaInterventoId(null);

        toast.success(
          "Intervento rimosso dalla Flotta."
        );

        return;
      }

      if (
        !intervento.indirizzo ||
        !String(intervento.indirizzo).trim()
      ) {
        toast.warning(
          "Inserisci prima un indirizzo valido."
        );
        return;
      }

      const result =
        await setFlottaDestination(
          intervento.id
        );

      setFlottaInterventoId(
        result?.intervention?.id ||
          intervento.id
      );

      toast.success(
        "Destinazione Fiorino aggiornata."
      );
    } catch (error) {
      console.error(
        "Errore modifica Flotta:",
        error
      );

      toast.error(
        error.response?.data?.error ||
          (giaInFlotta
            ? "Impossibile rimuovere dalla Flotta."
            : "Impossibile impostare la destinazione.")
      );
    }
  };

  const fetchInterventi = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      console.log("ðŸ“¡ Richiesta interventi con token:", token ? token.substring(0, 20) + "..." : "NESSUN TOKEN");
      const response = await axios.get(`${API_BASE_URL}/interventi`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
  
      console.log("âœ… Interventi ricevuti:", response.data.length, "elementi");
      const interventiNormalizzati = response.data.map((intervento) => ({
        ...intervento,
        indirizzo: intervento.indirizzo ?? "", // Usa nullish coalescing per garantire una stringa
      }));
      const STATI_DA_CLASSIFICARE = new Set(["Da classificare"]);
      const STATI_CHIUSI = new Set(["Completato", "CHIUSO fatturato"]);

      const interventiDaClassificare = interventiNormalizzati.filter((i) => {
        if (!STATI_DA_CLASSIFICARE.has(i.stato)) return false;
        if (!i.email_analisi_json) return true;

        try {
          const analysis =
            typeof i.email_analisi_json === "object"
              ? i.email_analisi_json
              : JSON.parse(i.email_analisi_json);
          return analysis?.isInterventionRequest !== false;
        } catch (error) {
          // Dato legacy/malformato: non nasconderlo automaticamente.
          return true;
        }
      });

      const interventiChiusi = interventiNormalizzati.filter(
        (i) => STATI_CHIUSI.has(i.stato)
      );

      /*
       * Tutto ciÃ² che non Ã¨ da classificare o chiuso
       * deve restare visibile tra gli interventi aperti.
       * Comprende Da fare, In corso, In pausa ed eventuali
       * stati anomali che altrimenti diventerebbero invisibili.
       */
      const interventiAperti = interventiNormalizzati.filter(
        (i) =>
          !STATI_DA_CLASSIFICARE.has(i.stato) &&
          !STATI_CHIUSI.has(i.stato)
      );

setInterventi(interventiAperti);
setInterventiDaClassificare(interventiDaClassificare);
setInterventiChiusi(interventiChiusi);
    } catch (error) {
      console.error("âŒ Errore nel recupero interventi:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
      toast.error("Errore nel recupero degli interventi!");
    } finally {
      setIsLoading(false);
      await fetchFlottaDestination();
    }
  };


  // Funzione per il fetch dei preventivi
  const fetchPreventivi = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/preventivi`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        withCredentials: true,
      });
      console.log("ðŸ“„ Dati preventivi caricati:", response.data);
      setPreventivi(response.data);
      console.log("ðŸ“„ fetchPreventivi completato");
    } catch (error) {
      console.error("âŒ Errore durante il recupero dei preventivi:", error.response ? error.response.data : error.message);
      toast.error("Errore nel caricamento dei preventivi!");
    } finally {
      setIsLoading(false);
    }
  };

// Funzione per il download del PDF di un preventivo
const handleDownloadPreventivoPDF = async (id) => {
  try {
    console.log("ðŸ“„ Tentativo download PDF per ID:", id);
    console.log("ðŸ“„ Stato preventivi:", preventivi);
    const preventivo = preventivi.find((p) => p.id === id);
    console.log("ðŸ“„ Preventivo trovato:", preventivo);
    if (!preventivo) {
      toast.error("Preventivo non trovato!");
      return;
    }
    const token = localStorage.getItem("token");
    console.log("ðŸ“„ Token utilizzato:", token ? token.substring(0, 20) + "..." : "NESSUN TOKEN");
    if (!token) {
      toast.error("Nessun token trovato. Effettua il login.");
      return;
    }
    const response = await axios.get(`${API_BASE_URL}/preventivi/${id}?format=pdf`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
      withCredentials: true,
    });
    console.log("ðŸ“„ Risposta API:", response);
    const blob = await response.data;
    if (!blob || blob.type !== "application/pdf") {
      throw new Error("Risposta non valida: non Ã¨ un PDF");
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `preventivo_${id}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    toast.success("PDF scaricato!");
  } catch (error) {
    console.error("âŒ Errore nel download del PDF:", error);
    console.error("âŒ Dettagli errore:", {
      status: error.response?.status,
      data: error.response?.data,
    });
    if (error.response?.status === 404) {
      toast.error("Preventivo non trovato o PDF non disponibile!");
    } else {
      toast.error(`Errore: ${error.message}`);
    }
  }
};

// Funzioni per i preventivi
const handleAddPreventivo = () => {
  setSelectedPreventivo(null);
  setPreventivoModalMode("create");
  setIsPreventivoModalOpen(true);
};

const handleEditPreventivo = async (preventivo) => {
  console.log("ðŸ“„ Modal aperto in modalitÃ :", "edit");
  try {
    const response = await axios.get(`${API_BASE_URL}/preventivi/${preventivo.id}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      withCredentials: true,
    });
    const updatedPreventivo = response.data;
    console.log("ðŸ“„ Preventivo aggiornato per modifica:", updatedPreventivo);
    setSelectedPreventivo(updatedPreventivo);
    setPreventivoModalMode("edit");
    setIsPreventivoModalOpen(true);
  } catch (error) {
    console.error("âŒ Errore nel recupero del preventivo:", error.response ? error.response.data : error.message);
    toast.error("Errore nel caricamento del preventivo!");
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("ðŸ“„ Materiali prima dell'invio:", materiali);
    // ... resto del codice
  };
};

const handleDeletePreventivo = async (id) => {
  if (!window.confirm("Sei sicuro di voler cancellare questo preventivo?")) return;
  try {
    const token = localStorage.getItem("token");
    await axios.delete(`${API_BASE_URL}/preventivi/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    setPreventivi(preventivi.filter((p) => p.id !== id));
    toast.success("Preventivo cancellato!");
  } catch (error) {
    console.error("âŒ Errore nella cancellazione del preventivo:", error);
    toast.error("Errore nella cancellazione del preventivo!");
  }
};

const handleSavePreventivo = async (newPreventivo) => {
  setIsPreventivoModalOpen(false);
  // Ricarica i preventivi per aggiornare i dati
  await fetchPreventivi();
};

  const handleAddMateriale = async () => {
    const codice = String(codiceMateriale || "").trim();
    const quantita = Number.parseFloat(quantitaMateriale);
    const prezzo = Number.parseFloat(prezzoUnitario);

    if (
      !codice ||
      !Number.isFinite(quantita) ||
      quantita <= 0 ||
      !Number.isFinite(prezzo) ||
      prezzo < 0
    ) {
      toast.error(
        "Compila codice, quantità positiva e prezzo valido"
      );
      return;
    }

    if (!selectedIntervento?.id) {
      toast.error(
        "Salva prima l'intervento per poter aggiungere materiali"
      );
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${API_BASE_URL}/aggiungi-materiale`,
        {
          id_intervento: selectedIntervento.id,
          materiale_id: materialeCatalogoId,
          codiceMateriale: codice,
          descrizioneMateriale,
          quantitaMateriale: quantita,
          prezzoUnitario: prezzo,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      console.log(
        "Materiale aggiunto con ID:",
        response.data.id
      );

      await fetchMateriali(selectedIntervento.id);

      setMaterialeCatalogoId(null);
      setCodiceMateriale("");
      setDescrizioneMateriale("");
      setQuantitaMateriale("");
      setPrezzoUnitario("");
      setTotale("");

      toast.success("Materiale aggiunto!");
    } catch (error) {
      console.error(
        "Errore nell'aggiunta del materiale:",
        error
      );

      toast.error(
        "Errore nell'aggiunta del materiale!"
      );
    }
  };

  const aggiungiMateriale = (materiale) => {
    const token = localStorage.getItem("token");
    axios
      .post(`${API_BASE_URL}/aggiungi-materiale`, materiale, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((response) => {
        setMateriali([...materiali, { ...materiale, id: response.data.id }]);
      })
      .catch((error) => {
        console.error("Errore nell'aggiunta del materiale:", error);
      });
  };

  const fetchMedia = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/media/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setMediaItems(response.data);
    } catch (error) {
      console.error("Errore nel recupero dei media", error);
    }
  };

  const handleDownloadPDF = async (interventoId) => {
    console.log("ðŸ” Generazione PDF per intervento ID:", interventoId);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/interventi/${interventoId}?format=pdf`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
        withCredentials: true,
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = fileURL;
      const contentDisposition = response.headers?.["content-disposition"] || "";
      const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
      a.download = fileNameMatch?.[1] || `Intervento_${interventoId}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(fileURL);

      toast.success("PDF scaricato con successo!");
    } catch (error) {
      console.error("âŒ Errore nel download del PDF:", error);
      toast.error("Errore nel download del PDF!");
    }
  };

  // === EMAIL CLASSIFICAZIONE INTELLIGENTE V1 - 2026-08-13 ===
  const handleSaveChanges = async () => {
    console.log("ðŸ“Œ Modal Mode:", modalMode);
    console.log("ðŸ“Œ Selected Intervento:", selectedIntervento);
  
    const clienteEffettivo = String(
      cliente || selectedIntervento?.cliente || ""
    ).trim();

    const indirizzoEffettivo = String(
      indirizzo || selectedIntervento?.indirizzo || ""
    ).trim();

    const causaleEffettiva = String(
      causale || selectedIntervento?.causale || ""
    ).trim();


    const descrizioneEffettiva = String(

      descrizione || selectedIntervento?.descrizione || ""

    ).trim();

    if (
      isClassificazione &&
      (!clienteEffettivo || !indirizzoEffettivo || !causaleEffettiva || !descrizioneEffettiva)
    ) {
      toast.warning(
        "Compila Cliente, Indirizzo, Causale e Richiesta / segnalazione prima di creare l’intervento."
      );
      return;
    }

    if (modalMode === "create" && !causaleEffettiva) {
      toast.warning("Compila la Causale prima di creare l'intervento.");
      return;
    }

    const kmPercorsiNum = kmPercorsi === "" || isNaN(parseInt(kmPercorsi, 10)) ? 0 : parseInt(kmPercorsi, 10);
    const pagatoNum = pagato ? 1 : 0;
    const minutiPausaNum = Number.isFinite(Number(minutiPausa)) ? Number(minutiPausa) : 0;
  
    const interventoDaSalvare = {
      cliente_id: clienteId || selectedIntervento?.cliente_id || "",
      sito_id: sitoClientePortaleId || selectedIntervento?.sito_id || "",
      cliente: clienteEffettivo,
      indirizzo: indirizzoEffettivo,
      telefono: telefono || selectedIntervento?.telefono || "",
      email: email || selectedIntervento?.email || "",
      piva: piva || selectedIntervento?.piva || "",
      causale: causaleEffettiva,
      descrizione: descrizioneEffettiva,
      tipoIntervento: JSON.stringify(
        tipoIntervento ||
          (selectedIntervento?.tipoIntervento
            ? JSON.parse(selectedIntervento.tipoIntervento)
            : { garanzia: false, manutenzione: false, pagamento: false, installazione: false, ultimare: false })
      ),
      lavoriEseguiti: isClassificazione
        ? ""
        : lavoriEseguiti || selectedIntervento?.lavoriEseguiti || "",
      tecnico: tecnico || selectedIntervento?.tecnico || "",
      data: data || selectedIntervento?.data || new Date().toISOString().split("T")[0],
      oraInizio: oraInizio || selectedIntervento?.oraInizio || "",
      oraFine: oraFine || selectedIntervento?.oraFine || "",
      kmPercorsi: kmPercorsiNum,
      metodoPagamento: metodoPagamento || selectedIntervento?.metodoPagamento || "",
      pagato: pagatoNum,
      trasferta: trasferta || selectedIntervento?.trasferta || "",
      tempoPercorrenza: tempoPercorrenza || selectedIntervento?.tempoPercorrenza || "",
      numeroFoglioIntervento: numeroFoglioIntervento || selectedIntervento?.numero_foglio_intervento || "",
      stato: isClassificazione
        ? "Da fare"
        : stato || selectedIntervento?.stato || "Da fare",
      pausa_totale_min: minutiPausaNum,
      pausaTotaleMin: minutiPausaNum,
      durataMinuti: null,

      costiTrasfertaDettaglio: JSON.stringify(costiTrasfertaDettaglio),
    };
  
    console.log("ðŸ“¡ Dati inviati al server:", interventoDaSalvare);
  
    try {
      let response;
  
      const formData = new FormData();
      for (const key in interventoDaSalvare) {
        if (interventoDaSalvare[key] !== null) {
          formData.append(key, interventoDaSalvare[key]);
        }
      }
  
      if (selectedFiles.length > 0) {
        formData.append("mediaFile", selectedFiles[0]);
      }
  
      if (extraMediaFiles.length > 0) {
        extraMediaFiles.forEach((file, index) => {
          formData.append(`mediaExtra`, file);
        });
      }
  
      const token = localStorage.getItem("token");
      if (modalMode === "create") {
        console.log("ðŸ“¡ Creazione nuovo intervento...");
        response = await axios.post(`${API_BASE_URL}/interventi`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`,
          },
          withCredentials: true,
        });
        toast.success("Intervento creato!");
        const nuovoIntervento = {
          ...response.data,
          indirizzo: response.data.indirizzo ?? "", // Normalizza
        };
        setInterventi((prev) => [...prev, nuovoIntervento]);
      } else if (modalMode === "edit" && selectedIntervento?.id) {
        console.log(`ðŸ“¡ Modifica intervento ID ${selectedIntervento.id}...`);
        response = await axios.put(`${API_BASE_URL}/interventi/${selectedIntervento.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`,
          },
          withCredentials: true,
        });
        toast.success("Intervento aggiornato!");
        const interventoAggiornato = {
          ...response.data,
          indirizzo: response.data.indirizzo ?? "", // Normalizza
        };
        setInterventi((prev) =>
          prev.map((i) => (i.id === selectedIntervento.id ? interventoAggiornato : i))
        );
      } else {
        console.error("âŒ Errore: Modal Mode non valido o ID intervento mancante!");
        toast.error("Modal Mode non valido o ID intervento mancante!");
        return;
      }
  
      console.log("âœ… Risposta dal server:", response.data);
  
      const updatedIntervento = response.data;
      setNumeroFoglioIntervento(updatedIntervento.numeroFoglioIntervento);
      if (updatedIntervento.immagine) {
        setPreviewFiles([{ url: `${API_BASE_URL}${updatedIntervento.immagine}`, type: "image/jpeg" }]);
      } else {
        setPreviewFiles([]);
      }
  
      if (updatedIntervento.media && updatedIntervento.media.length > 0) {
        const mediaPreviews = updatedIntervento.media.map((media) => ({
          url: `${API_BASE_URL}${media.url}`,
          type:
            media.tipo === "foto"
              ? "image/jpeg"
              : media.tipo === "video"
              ? "video/mp4"
              : "audio/mpeg",
        }));
        setExtraMediaPreviews(mediaPreviews);
      } else {
        setExtraMediaPreviews([]);
      }
  
      setSelectedFiles([]);
      setExtraMediaFiles([]);

      await fetchInterventi();

      if (interventoDaSalvare.stato === "Da classificare") {
        setActiveTab("daClassificare");
      } else if (
        ["Completato", "CHIUSO fatturato"].includes(
          interventoDaSalvare.stato
        )
      ) {
        setActiveTab("chiusi");
      } else {
        setActiveTab("attivita");
      }

      clearInterventoDraftAliases({
        interventoId: selectedIntervento?.id || null,
        numeroFoglioIntervento: numeroFoglioIntervento || "",
      });

      setIsModalOpen(false);
    } catch (error) {
      console.error("âŒ Errore nell'operazione:", error.response?.data || error.message || error);
      toast.error(`Errore durante l'operazione: ${error.response?.data?.error || error.message || "Errore sconosciuto"}`);
    }
  };

  // === BETALUMINA ELIMINA DA CLASSIFICARE UI V1 - 2026-08-19 ===
  const handleDeleteDaClassificare = async (richiesta) => {
    const id = Number(richiesta?.id);

    if (!Number.isFinite(id) || id <= 0) {
      toast.error("Errore: richiesta non valida.");
      return false;
    }

    const riferimento =
      richiesta?.numero_foglio_intervento || `ID ${id}`;

    const confermato = window.confirm(
      `Eliminare definitivamente ${riferimento} dalla sezione Da classificare?\n\n` +
      "L'email resterà segnata come già elaborata e non verrà importata nuovamente."
    );

    if (!confermato) {
      return false;
    }

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${API_BASE_URL}/interventi-da-classificare/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );

      toast.success("Richiesta eliminata da Da classificare.");
      await fetchInterventi();
      return true;
    } catch (error) {
      console.error(
        "Errore eliminazione richiesta Da classificare:",
        error
      );

      const message =
        error.response?.data?.message ||
        "Errore durante l'eliminazione della richiesta.";

      toast.error(message);

      if (error.response?.status === 409) {
        await fetchInterventi();
      }

      return false;
    }
  };
  // === END BETALUMINA ELIMINA DA CLASSIFICARE UI V1 ===

  const handleDeleteIntervento = async (id) => {
    if (!id) {
      console.error("âŒ ID non valido o mancante:", id);
      toast.error("Errore: ID intervento non valido!");
      return;
    }
    if (!window.confirm("Sei sicuro di voler cancellare questo intervento?")) return;
    try {
      console.log("Tentativo di cancellazione per ID:", id);
      const token = localStorage.getItem("token");
      await axios.delete(`${API_BASE_URL}/interventi/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      toast.success("Intervento cancellato!");
      fetchInterventi();
    } catch (error) {
      console.error("Errore nella cancellazione dell'intervento", error);
      if (error.response) {
        console.error("Dettagli risposta del server:", error.response.data);
        toast.error(`Errore: ${error.response.data.message || "Errore durante la cancellazione dell'intervento!"}`);
      } else {
        toast.error("Errore durante la cancellazione dell'intervento!");
      }
    }
  };

  const handleEditMateriale = (materiale) => {
    setMaterialeCatalogoId(
      materiale.materiale_id ?? null
    );

    setCodiceMateriale(
      materiale.codiceMateriale || ""
    );

    setDescrizioneMateriale(
      materiale.descrizioneMateriale || ""
    );

    setQuantitaMateriale(
      materiale.quantitaMateriale ?? ""
    );

    setPrezzoUnitario(
      materiale.prezzoUnitario ?? ""
    );

    setTotale(materiale.totale ?? "");
    setMaterialeDaModificare(materiale.id);
  };

  const handleDeleteMateriale = async (id) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token non trovato. Effettua il login.");
      }

      
      await axios.delete(`${API_BASE_URL}/elimina-materiale/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      setMateriali((prevMateriali) => {
        const newMateriali = prevMateriali.filter((materiale) => materiale.id !== id);
        console.log("Materiali dopo l'eliminazione:", newMateriali);
        return newMateriali;
      });

      toast.success("Materiale eliminato con successo");
    } catch (error) {
      console.error("âŒ Errore nell'eliminazione del materiale:", error);
      if (error.message === "Token non trovato. Effettua il login.") {
        toast.error("Devi effettuare il login per eliminare un materiale.");
      } else if (error.response?.status === 403) {
        toast.error("Accesso negato: token non valido o scaduto. Effettua nuovamente il login.");
      } else {
        toast.error("Errore nell'eliminazione del materiale!");
      }
    }
  };

  const handleUpdateMateriale = async () => {
    const quantita = Number.parseFloat(quantitaMateriale);
    const prezzo = Number.parseFloat(prezzoUnitario);

    if (
      !materialeDaModificare ||
      !String(codiceMateriale || "").trim() ||
      !Number.isFinite(quantita) ||
      quantita <= 0 ||
      !Number.isFinite(prezzo) ||
      prezzo < 0
    ) {
      toast.error(
        "Compila codice, quantità positiva e prezzo valido"
      );
      return;
    }

    try {
      const token = localStorage.getItem("token");

      await axios.put(
        `${API_BASE_URL}/modifica-materiale/${materialeDaModificare}`,
        {
          materiale_id: materialeCatalogoId,
          codiceMateriale: String(codiceMateriale).trim(),
          descrizioneMateriale,
          quantitaMateriale: quantita,
          prezzoUnitario: prezzo,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );

      setMateriali((prevMateriali) =>
        prevMateriali.map((mat) =>
          Number(mat.id) === Number(materialeDaModificare)
            ? {
                ...mat,
                materiale_id: materialeCatalogoId,
                codiceMateriale: String(
                  codiceMateriale
                ).trim(),
                descrizioneMateriale,
                quantitaMateriale: quantita,
                prezzoUnitario: prezzo,
                totale: quantita * prezzo,
              }
            : mat
        )
      );

      toast.success(
        "Materiale aggiornato con successo!"
      );

      setMaterialeCatalogoId(null);
      setCodiceMateriale("");
      setDescrizioneMateriale("");
      setQuantitaMateriale("");
      setPrezzoUnitario("");
      setTotale("");
      setMaterialeDaModificare(null);
    } catch (error) {
      console.error(
        "Errore nella modifica del materiale:",
        error
      );

      toast.error(
        "Errore nella modifica del materiale!"
      );
    }
  };

  const handleClienteCreatoInline = (creato) => {
    if (!creato?.id) return;

    setClienti((prev) => {
      const aggiornati = [
        ...prev.filter((item) => Number(item.id) !== Number(creato.id)),
        creato,
      ];

      aggiornati.sort((a, b) =>
        String(a.nome || "").localeCompare(
          String(b.nome || ""),
          "it",
          { sensitivity: "base" }
        )
      );

      return aggiornati;
    });
  };

  const fetchClienti = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_BASE_URL}/clienti`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setClienti(response.data);
      console.log("âœ… Clienti ricevuti:", response.data);
    } catch (error) {
      console.error("âŒ Errore nel recupero dei clienti:", error);
      toast.error("Errore nel recupero dei clienti!");
    }
  };

  const handleSaveCliente = async () => {
    try {
      const formData = new FormData();
      for (const key in selectedCliente) {
        if (selectedCliente[key] !== null && selectedCliente[key] !== undefined) {
          formData.append(key, selectedCliente[key]);
        }
      }

      for (const key in clienteFiles) {
        const files = Array.isArray(clienteFiles[key]) ? clienteFiles[key] : [];
        files.forEach((file) => {
          if (file) formData.append(key, file);
        });
      }

      const token = localStorage.getItem("token");
      let response;
      if (clienteModalMode === "create") {
        response = await axios.post(`${API_BASE_URL}/clienti`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        toast.success("Cliente creato!");
        setClienti((prev) => [...prev, response.data]);
      } else if (clienteModalMode === "edit" && selectedCliente?.id) {
        response = await axios.put(`${API_BASE_URL}/clienti/${selectedCliente.id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        toast.success("Cliente aggiornato!");
        setClienti((prev) =>
          prev.map((c) => (c.id === selectedCliente.id ? response.data : c))
        );
      }

      fetchClienti();
      handleCloseClienteModal();
    } catch (error) {
      console.error("âŒ Errore nell'operazione:", error);
      toast.error("Errore durante l'operazione!");
    }
  };

  const handleDeleteCliente = async (id) => {
    if (!window.confirm("Sei sicuro di voler cancellare questo cliente?")) return;
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_BASE_URL}/clienti/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      toast.success("Cliente cancellato!");
      fetchClienti();
    } catch (error) {
      console.error("âŒ Errore nella cancellazione del cliente:", error);
      toast.error("Errore nella cancellazione del cliente!");
    }
  };

  // Resto del codice (handleOpenModal, handleCloseInterventoStatus, ecc.) rimane invariato
  // Assicurati che tutte le funzioni che fanno richieste usino API_BASE_URL

  const handleDateClick = (selectedDate) => {
    setDate(selectedDate);
    setCliente("");
    setStato("Da fare");
    setModificaId(null);
    handleOpenModal("create");
  };

  const handleStatoChange = (newStato) => {
    setStato(newStato);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setTipoIntervento((prev) => {
      if (typeof prev === "string") {
        try {
          prev = JSON.parse(prev);
        } catch (error) {
          console.error("âŒ Errore nel parsing di tipoIntervento:", error);
          prev = {};
        }
      }
      return { ...prev, [name]: checked };
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
    const previews = files.map((file) => {
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onloadend = () => resolve({ url: reader.result, type: file.type });
        reader.readAsDataURL(file);
      });
    });
    Promise.all(previews).then((files) => setPreviewFiles(files));
  };

  const handleExtraMediaChange = (e) => {
    const files = Array.from(e.target.files);
    setExtraMediaFiles(files);
    const previews = files.map((file) => {
      const reader = new FileReader();
      return new Promise((resolve) => {
        reader.onloadend = () => resolve({ url: reader.result, type: file.type });
        reader.readAsDataURL(file);
      });
    });
    Promise.all(previews).then((files) => setExtraMediaPreviews(files));
  };

  const handleCanvasMouseDown = (e) => {
    if (!canvasRef.current) return;
    const rect = canvasRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setIsDrawing(true);
    setLastPos({ x, y });
  };

  const handleCanvasMouseMove = (e) => {
    if (!isDrawing || !canvasRef.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    ctx.strokeStyle = "#FF0000";
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.moveTo(lastPos.x, lastPos.y);
    ctx.lineTo(x, y);
    ctx.stroke();
    setLastPos({ x, y });
  };

  const handleCanvasMouseUp = () => {
    setIsDrawing(false);
  };

  const handleOpenModal = (mode, intervento = null) => {
    setModalMode(mode);
    setSelectedIntervento(intervento);

    if (mode === "edit" && intervento) {
      console.log("ðŸ“… Data dell'intervento prima di impostarla nel form:", intervento.data);
      setCliente(intervento.cliente || "");
      setClienteId(intervento.cliente_id || null);
      setSitoClientePortaleId(intervento.sito_id ? String(intervento.sito_id) : "");
      setIndirizzo(intervento.indirizzo || "");
      setTelefono(intervento.telefono || "");
      setEmail(intervento.email || "");
      setPiva(intervento.piva || "");
      setCausale(intervento.causale || "");
      setDescrizione(intervento.descrizione || "");
      // === BETALUMINA FIX MODIFICA TIPO_INTERVENTO COMPAT V1 - 2026-08-19 ===
      const tipoInterventoFallback = {
        garanzia: false,
        manutenzione: false,
        pagamento: false,
        installazione: false,
        ultimare: false,
      };

      let tipoInterventoForm = tipoInterventoFallback;
      const tipoInterventoRaw = intervento.tipoIntervento;

      if (
        tipoInterventoRaw &&
        typeof tipoInterventoRaw === "object" &&
        !Array.isArray(tipoInterventoRaw)
      ) {
        tipoInterventoForm = {
          ...tipoInterventoFallback,
          ...tipoInterventoRaw,
        };
      } else if (typeof tipoInterventoRaw === "string") {
        try {
          const parsedTipoIntervento = JSON.parse(tipoInterventoRaw);
          if (
            parsedTipoIntervento &&
            typeof parsedTipoIntervento === "object" &&
            !Array.isArray(parsedTipoIntervento)
          ) {
            tipoInterventoForm = {
              ...tipoInterventoFallback,
              ...parsedTipoIntervento,
            };
          }
        } catch (error) {
          console.warn(
            "BETALUMINA_TIPOINTERVENTO_COMPAT_V1",
            "tipoIntervento non è una stringa JSON valida; uso valori di default:",
            error
          );
        }
      }

      setTipoIntervento(tipoInterventoForm);
      // === END BETALUMINA FIX MODIFICA TIPO_INTERVENTO COMPAT V1 ===
      setLavoriEseguiti(intervento.lavoriEseguiti || "");
      setTecnico(intervento.tecnico || "");
      setData(intervento.data ? normalizeDateForInput(intervento.data) : "");
      setOraInizio(intervento.oraInizio || "");
      setOraFine(intervento.oraFine || "");
      setKmPercorsi(intervento.kmPercorsi || "");
      setMetodoPagamento(intervento.metodoPagamento || "");
      setPagato(intervento.pagato || "");
      setTrasferta(intervento.trasferta || "");
      setCostiTrasfertaDettaglio(parseCostiTrasfertaDettaglio(intervento.costiTrasfertaDettaglio));
      setTempoPercorrenza(intervento.tempoPercorrenza || "");
      setNumeroFoglioIntervento(intervento.numero_foglio_intervento || "");
            setMinutiPausa(
        Number.isFinite(Number(intervento.pausa_totale_min))
          ? Number(intervento.pausa_totale_min)
          : Number.isFinite(Number(intervento.pausaTotaleMin))
          ? Number(intervento.pausaTotaleMin)
          : 0
      );
      setPausaInizio(intervento.pausa_inizio ?? intervento.pausaInizio ?? null);

      setStato(intervento.stato || "Da fare");

      if (intervento.id) {
        fetchMateriali(intervento.id);
      }
    } else {
      setCliente("");
      setClienteId(null);
      setSitoClientePortaleId("");
      setIndirizzo("");
      setTelefono("");
      setEmail("");
      setPiva("");
      setCausale("");
      setTipoIntervento({
        garanzia: false,
        manutenzione: false,
        pagamento: false,
        installazione: false,
        ultimare: false,
      });
      setLavoriEseguiti("");
      setTecnico("");
      setData(new Date().toISOString().split("T")[0]);
      setOraInizio("");
      setOraFine("");
      setKmPercorsi("");
      setMetodoPagamento("");
      setPagato("");
      setTrasferta("");
    setCostiTrasfertaDettaglio(emptyCostiTrasfertaDettaglio());
      setTempoPercorrenza("");
      setNumeroFoglioIntervento("");
      setStato("Da fare");
      setMateriali([]);
      setMinutiPausa(0);
      setPausaInizio(null);

    }

    setIsModalOpen(true);
  };

  const handleCloseInterventoStatus = async (id) => {
    if (!id) {
      toast.error("Errore: ID Intervento non valido!");
      return;
    }

    const intervento = interventi.find((i) => i.id === id) || interventiChiusi.find((i) => i.id === id);
    if (!intervento) {
      toast.error("Intervento non trovato!");
      return;
    }

    setSelectedIntervento(intervento);
    setCliente(intervento.cliente || "");
    setIndirizzo(intervento.indirizzo || "");
    setTelefono(intervento.telefono || "");
    setEmail(intervento.email || "");
    setPiva(intervento.piva || "");
    setCausale(intervento.causale || "");
    setDescrizione(intervento.descrizione || "");
    setTipoIntervento(
      JSON.parse(intervento.tipoIntervento || "{}") || {
        garanzia: false,
        manutenzione: false,
        pagamento: false,
        installazione: false,
        ultimare: false,
      }
    );
    setOraInizio(intervento.oraInizio || "");
    setOraFine(intervento.oraFine || "");
    setStato("Completato");
    setLavoriEseguiti(intervento.lavoriEseguiti || "");
    setTecnico(intervento.tecnico || "");
    setData(intervento.data ? new Date(intervento.data).toISOString().split("T")[0] : "");
    setKmPercorsi(intervento.kmPercorsi || "");
    setTempoPercorrenza(intervento.tempoPercorrenza || "");
    setTrasferta(intervento.trasferta || "");
      setCostiTrasfertaDettaglio(parseCostiTrasfertaDettaglio(intervento.costiTrasfertaDettaglio));
    setPagato(!!intervento.pagato);
    setMetodoPagamento(intervento.metodoPagamento || "");
    setNumeroFoglioIntervento(intervento.numero_foglio_intervento || "");

    await handleSaveChanges();

    setInterventi((prev) => prev.filter((i) => i.id !== id));
    setInterventiChiusi((prev) => [...prev, { ...intervento, stato: "Completato" }]);
    toast.success("Intervento chiuso con successo!");
  };

  const handleRemovePreviewFile = (index) => {
    setPreviewFiles((prev) => prev.filter((_, i) => i !== index));
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveExtraMediaPreview = (index) => {
    setExtraMediaPreviews((prev) => prev.filter((_, i) => i !== index));
    setExtraMediaFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const [clienti, setClienti] = useState([]);
  const [isClienteModalOpen, setIsClienteModalOpen] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [clienteModalMode, setClienteModalMode] = useState("create");
  const [clienteFiles, setClienteFiles] = useState({
    foto_impianto: [],
    documenti_firmati: [],
    verbale_collaudo: [],
    manualistica: [],
    certificazioni: [],
  });
  const [clientePreviewFiles, setClientePreviewFiles] = useState({
    foto_impianto: [],
    documenti_firmati: [],
    verbale_collaudo: [],
    manualistica: [],
    certificazioni: [],
  });

  const toClienteInputDate = (value) => {
    if (!value || value === "-" || value === "0000-00-00") return "";
    if (typeof value !== "string") return "";

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

    const match = value.match(/^(\d{2})\/(\d{2})\/(\d{2}|\d{4})$/);
    if (match) {
      const [, day, month, yearRaw] = match;
      const year = yearRaw.length === 2 ? `20${yearRaw}` : yearRaw;
      return `${year}-${month}-${day}`;
    }

    return "";
  };

  const parseClienteFileList = (value) => {
    if (!value || value === "-" || value === "null") return [];
    if (Array.isArray(value)) return value.filter(Boolean);

    const text = String(value).trim();
    if (!text) return [];

    try {
      const parsed = JSON.parse(text);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      if (typeof parsed === "string" && parsed.trim()) return [parsed];
    } catch (error) {
      // Valore storico singolo tipo /uploads/file.pdf: lo manteniamo compatibile.
    }

    return [text];
  };

  const serializeClienteFileList = (paths) => JSON.stringify((paths || []).filter(Boolean));

  const createClienteFilePreview = (filePath) => {
    return parseClienteFileList(filePath).map((pathValue) => {
      const name = String(pathValue).split("/").pop();
      const url = String(pathValue).startsWith("http")
        ? pathValue
        : `${API_BASE_URL}${pathValue}`;

      return { name, url, path: pathValue, isNew: false };
    });
  };

  const normalizeClienteForModal = (cliente) => {
    if (!cliente) return null;

    return {
      ...cliente,
      data_installazione: toClienteInputDate(cliente.data_installazione),
      data_ultimo_intervento: toClienteInputDate(cliente.data_ultimo_intervento),
      scadenza_prossima_manutenzione: toClienteInputDate(cliente.scadenza_prossima_manutenzione),
      invio_email_scadenza:
        cliente.invio_email_scadenza === true ||
        cliente.invio_email_scadenza === 1 ||
        cliente.invio_email_scadenza === "1" ||
        cliente.invio_email_scadenza === "true",
    };
  };

  const handleOpenClienteModal = (mode, cliente = null) => {
    setClienteModalMode(mode);
    const clienteNormalizzato = normalizeClienteForModal(cliente);
    setSelectedCliente(clienteNormalizzato || {
      nome: "",
      indirizzo: "",
      telefono: "",
      telefono_secondario: "",
      email: "",
      codice_fiscale: "",
      referente: "",
      tipo_impianto: "",
      data_installazione: "",
      marca_modello: "",
      numero_matricola: "",
      numero_contratto: "",
      stato_garanzia: "",
      tipo_manutenzione: "",
      data_ultimo_intervento: "",
      scadenza_prossima_manutenzione: "",
      schemi_disegni: "",
      numero_zone: "",
      descrizione_configurazione: "",
      password_codici: "",
      note_interventi_futuri: "",
      foto_impianto: "",
      documenti_firmati: "",
      verbale_collaudo: "",
      manualistica: "",
      certificazioni: "",
      storico_interventi: "",
      problemi_ricorrenti: "",
      materiali_sostituiti: "",
      note_generali: "",
      invio_email_scadenza: false,
    });
    setClienteFiles({
      foto_impianto: [],
      documenti_firmati: [],
      verbale_collaudo: [],
      manualistica: [],
      certificazioni: [],
    });
    setClientePreviewFiles({
      foto_impianto: createClienteFilePreview(cliente?.foto_impianto),
      documenti_firmati: createClienteFilePreview(cliente?.documenti_firmati),
      verbale_collaudo: createClienteFilePreview(cliente?.verbale_collaudo),
      manualistica: createClienteFilePreview(cliente?.manualistica),
      certificazioni: createClienteFilePreview(cliente?.certificazioni),
    });
    setIsClienteModalOpen(true);
  };

  const handleCloseClienteModal = () => {
    setIsClienteModalOpen(false);
    setSelectedCliente(null);
    setClienteFiles({
      foto_impianto: [],
      documenti_firmati: [],
      verbale_collaudo: [],
      manualistica: [],
      certificazioni: [],
    });
    setClientePreviewFiles({
      foto_impianto: [],
      documenti_firmati: [],
      verbale_collaudo: [],
      manualistica: [],
      certificazioni: [],
    });
  };

  const handleClienteFileChange = async (e, field) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    setClienteFiles((prev) => ({
      ...prev,
      [field]: [...(Array.isArray(prev[field]) ? prev[field] : []), ...files],
    }));

    const previews = await Promise.all(
      files.map((file) =>
        new Promise((resolve) => {
          if (file.type && file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onloadend = () => resolve({ name: file.name, url: reader.result, type: file.type, isNew: true });
            reader.readAsDataURL(file);
          } else {
            resolve({ name: file.name, url: null, type: file.type, isNew: true });
          }
        })
      )
    );

    setClientePreviewFiles((prev) => ({
      ...prev,
      [field]: [...(Array.isArray(prev[field]) ? prev[field] : []), ...previews],
    }));

    e.target.value = "";
  };

  const handleRemoveClientePreviewFile = (field, index) => {
    const currentPreviews = Array.isArray(clientePreviewFiles[field]) ? clientePreviewFiles[field] : [];
    const removed = currentPreviews[index];
    const nextPreviews = currentPreviews.filter((_, i) => i !== index);

    if (removed?.isNew) {
      const newFileIndex = currentPreviews
        .slice(0, index)
        .filter((preview) => preview?.isNew).length;

      setClienteFiles((prev) => ({
        ...prev,
        [field]: (Array.isArray(prev[field]) ? prev[field] : []).filter((_, i) => i !== newFileIndex),
      }));
    }

    const existingPaths = nextPreviews
      .filter((preview) => !preview?.isNew && preview?.path)
      .map((preview) => preview.path);

    setClientePreviewFiles((prev) => ({ ...prev, [field]: nextPreviews }));
    setSelectedCliente((prev) => (prev ? { ...prev, [field]: serializeClienteFileList(existingPaths) } : prev));
  };

  useEffect(() => {
    fetchClienti();
  }, []);

  useEffect(() => {
    if (modalMode === "create") {
      setCliente("");
      setIndirizzo("");
      setOraInizio("");
      setOraFine("");
      setStato("Da fare");
      setSelectedFiles([]);
      setPreviewFiles([]);
      setExtraMediaFiles([]);
      setExtraMediaPreviews([]);
    }
  }, [isModalOpen, modalMode]);

  useEffect(() => {
    if (
      previewFiles.length > 0 &&
      previewFiles[0].type.startsWith("image") &&
      canvasRef.current
    ) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
      };
      img.src = previewFiles[0].url;
    }
  }, [previewFiles]);


  useEffect(() => {
    const checkViewport = () => {
      if (window.innerWidth <= 1280) {
        console.log("ðŸ“± Schermo â‰¤1280px, sidebar nascosta");
        setIsSidebarOpen(false);
      } else {
        console.log("ðŸ’» Schermo >1280px, sidebar visibile");
        setIsSidebarOpen(true);
      }
    };
    checkViewport();
    window.addEventListener("resize", checkViewport);
    return () => {
      console.log("ðŸ§¹ Cleanup: rimuovo listener resize");
      window.removeEventListener("resize", checkViewport);
    };
  }, []);
  
  
  

  const getColorByStato = (stato) => {
    if (!stato) return "gray";
    switch (stato) {
      case "Da fare":
        return "red";
      case "In corso":
        return "orange";
      case "Completato":
        return "green";
      default:
        return "gray";
    }
  };

  const inizioSettimana = new Date(date);
  inizioSettimana.setDate(date.getDate() - date.getDay());

  const interventiSettimana = (interventi || []).filter((intervento) => {
    const dataIntervento = new Date(intervento.data);
    return dataIntervento >= inizioSettimana && dataIntervento <= new Date(inizioSettimana.getTime() + 6 * 86400000);
  });

  return (
    <div className="dashboard-container">
      <button className="hamburger" onClick={toggleSidebar}>
        <FaBars />
      </button>
      <aside className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <div className="sidebar-logo">
          <img src="/logo.png" alt="Logo" />
        </div>
        <h2 className="menu-title">Menu</h2>

        <button
  className={`menu-button ${
    activeTab === "daClassificare" ? "active" : ""
  }`}
  onClick={() => {
    setActiveTab("daClassificare");
    if (window.innerWidth <= 1280) setIsSidebarOpen(false);
  }}
>
  <FaBell className="menu-nav-icon menu-nav-icon--classificare" /> Da classificare
  {interventiDaClassificare.length > 0 && (
    <span
      style={{
        marginLeft: 8,
        background: "#d32f2f",
        color: "#fff",
        borderRadius: 20,
        padding: "2px 8px",
        fontSize: 12,
      }}
    >
      {interventiDaClassificare.length}
    </span>
  )}
</button>
  
        <button
          className={`menu-button ${activeTab === "home" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("home");

            if (window.innerWidth <= 1280) {
              setIsSidebarOpen(false);
            }
          }}
        >
          <FaHome className="menu-nav-icon menu-nav-icon--home" /> Home operativa
        </button>

        <button
          className={`menu-button ${activeTab === "attivita" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("attivita");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaTasks className="menu-nav-icon menu-nav-icon--aperti" /> Interventi Aperti
        </button>
  
        <button
          className={`menu-button ${activeTab === "chiusi" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("chiusi");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaCheckCircle className="menu-nav-icon menu-nav-icon--chiusi" /> Interventi Chiusi
        </button>
  
        <button
          className={`menu-button ${activeTab === "preventivi" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("preventivi");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaFileAlt className="menu-nav-icon menu-nav-icon--preventivi" /> Preventivi
        </button>
  
        <button
          className={`menu-button ${activeTab === "materiali" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("materiali");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaTools className="menu-nav-icon menu-nav-icon--materiali" /> Materiali
        </button>
  
        <button
          className={`menu-button ${activeTab === "clienti" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("clienti");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaUsers className="menu-nav-icon menu-nav-icon--clienti" /> Clienti
        </button>

        <button
          className={`menu-button ${activeTab === "flotta" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("flotta");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
        }}
>
  <FaTruck className="menu-nav-icon menu-nav-icon--flotta" /> Flotta
</button>
        <button
          className={`menu-button ${activeTab === "analisi" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("analisi");
            if (window.innerWidth <= 1280) {
              setIsSidebarOpen(false);
            }
          }}
        >
          <FaChartBar className="menu-nav-icon menu-nav-icon--analisi" /> Analisi
        </button>

        <button
          className={`menu-button ${activeTab === "cervello" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("cervello");
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaBrain className="menu-nav-icon menu-nav-icon--cervello" /> Cervello
        </button>

        <button
          type="button"
          className="menu-button calendar-launch-button"
          onClick={() => {
            setIsCalendarOpen(true);
            if (window.innerWidth <= 1280) setIsSidebarOpen(false);
          }}
        >
          <FaCalendarAlt className="menu-nav-icon menu-nav-icon--calendario" /> Calendario
        </button>
<PushNotificationControl />
<button
          className="logout-button"
          onClick={() => {
            localStorage.removeItem("token");
            navigate("/");
            toast.info("Logout effettuato!");
          }}
        >
          Logout
        </button>
      </aside>

      {isCalendarOpen && (
        <div
          className="calendar-popup-overlay"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              setIsCalendarOpen(false);
            }
          }}
        >
          <section
            className="calendar-popup"
            role="dialog"
            aria-modal="true"
            aria-label="Calendario interventi"
          >
            <header className="calendar-popup-header">
              <div>
                <h2>Calendario interventi</h2>
                <p>Agenda e pianificazione degli appuntamenti</p>
              </div>

              <button
                type="button"
                className="calendar-popup-close"
                onClick={() => setIsCalendarOpen(false)}
                aria-label="Chiudi calendario"
              >
                ×
              </button>
            </header>

            <div className="calendar-popup-body">
              {isLoading ? (
                <p>Caricamento calendario...</p>
              ) : (
                <Calendario
                  interventi={interventi}
                  fetchInterventi={fetchInterventi}
                  date={date}
                  setDate={setDate}
                  openModal={() => {
                    setIsCalendarOpen(false);
                    handleOpenModal("create");
                  }}
                />
              )}
            </div>
          </section>
        </div>
      )}

      <ClienteModal
            isOpen={isClienteModalOpen}
            onClose={handleCloseClienteModal}
            onSave={handleSaveCliente}
            cliente={selectedCliente}
            setClienteData={setSelectedCliente}
            handleFileChange={handleClienteFileChange}
            previewFiles={clientePreviewFiles}
            handleRemovePreviewFile={handleRemoveClientePreviewFile}
          />

<PreventivoModal
  isOpen={isPreventivoModalOpen}
  onClose={() => setIsPreventivoModalOpen(false)}
  onSave={handleSavePreventivo}
  selectedPreventivo={selectedPreventivo}
  modalMode={preventivoModalMode}
  handleDownloadPDF={handleDownloadPreventivoPDF}
/>


      <main className="content">
        {/* BETALUMINA_REAL_TOAST_PORTAL_FIX33F_20261025 */}
        {createPortal(
          <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />,
          document.body
        )}
        <h1 className="dashboard-title">Dashboard</h1>
        {activeTab === "home" && (
          <HomeOperativa
            richiesteDaClassificare={interventiDaClassificare}
            interventiAperti={interventi}
            flottaInterventoId={flottaInterventoId}
            onNavigate={setActiveTab}
          />
        )}

        {activeTab === "attivita" && (
          <TabellaInterventi
            interventi={interventi}
            tipo="aperti"
            onModifica={handleOpenModal}
            onCancella={handleDeleteIntervento}
            onPDF={handleDownloadPDF}
            onAggiungi={() => handleOpenModal("create")}
            onImpostaFlotta={handleImpostaFlotta}
            flottaInterventoId={flottaInterventoId}
          />
        )}

        {activeTab === "daClassificare" && (
          <InboxRichieste
            richieste={interventiDaClassificare}
            loading={isLoading}
            onClassifica={(richiesta) =>
              handleOpenModal("edit", richiesta)
            }
            onElimina={handleDeleteDaClassificare}
          />
        )}


        {/*activeTab === "chiusi" && (
          <div>
            <h3 className="chiusi-title">Interventi Chiusi</h3>
            {isLoading ? (
              <p>Caricamento...</p>
            ) : interventiChiusi.length === 0 ? (
              <p>Nessun intervento chiuso disponibile</p>
            ) : (
              <table className="interventi-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Cliente</th>
                    <th>Indirizzo</th>
                    <th>Data</th>
                    <th>Descrizione</th>
                    <th>Numero Foglio</th>
                    <th>Stato</th>
                    <th>Azioni</th>
                  </tr>
                </thead>
                <tbody>
                  {interventiChiusi.map((intervento) => (
                    <tr key={intervento.id}>
                      <td>{intervento.id}</td>
                      <td>{intervento.cliente || "/"}</td>
                      <td>{intervento.indirizzo || "/"}</td>
                      <td>{intervento.data ? new Date(intervento.data).toLocaleDateString() : "/"}</td>
                      <td>{intervento.causale && intervento.causale.trim() !== "" ? intervento.causale : "Senza causale"}</td>
                      <td>{intervento.numero_foglio_intervento || "/"}</td>
                      <td>
                        <span className="status-indicator" style={{ backgroundColor: getColorByStato(intervento.stato) }}></span>
                        {intervento.stato || "In corso"}
                      </td>
                      <td className="flex">
                        <button onClick={() => handleDownloadPDF(intervento.id)} className="pdf-btn">
                          <FaEye /> PDF
                        </button>
                        <button onClick={() => handleOpenModal("edit", intervento)} className="edit-btn">
                          <FaEdit /> Modifica
                        </button>
                        <button onClick={() => handleDeleteIntervento(intervento.id)} className="delete-btn">
                          <FaTrash /> Cancella
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )*/}
        {activeTab === "chiusi" && (
          <TabellaInterventi
          interventi={interventiChiusi}
          tipo="chiusi"
          onModifica={handleOpenModal}
          onCancella={handleDeleteIntervento}
          onPDF={handleDownloadPDF}
          />
        )}

{activeTab === "preventivi" && (
  <TabellaPreventivi
    preventivi={preventivi}
    onAddPreventivo={handleAddPreventivo}
    onEditPreventivo={handleEditPreventivo}
    onDeletePreventivo={handleDeletePreventivo}
    onDownloadPDF={handleDownloadPreventivoPDF}
  />
)}
        {activeTab === "materiali" && (
          <div>
            <h3 className="interventi-title">Gestione Materiali</h3>
            <Materiali />
          </div>
        )}
        {activeTab === "clienti" && (
          <div>
            <Clienti
              clienti={clienti}
              onAddCliente={() => handleOpenClienteModal("create")}
              onEditCliente={(cliente) => handleOpenClienteModal("edit", cliente)}
              onDeleteCliente={handleDeleteCliente}
            />
          </div>
        )}

        {activeTab === "flotta" && (
          <Flotta
            onApriIntervento={(intervento) => {
              const completo =
                interventi.find(
                  (item) =>
                    Number(item.id) ===
                    Number(intervento.id)
                ) || intervento;

              handleOpenModal(
                "edit",
                completo
              );
            }}
          />
        )}
        
        {activeTab === "analisi" && (
          <AnalisiDashboard />
        )}

        {activeTab === "cervello" && (
          <CervelloBetaLumina />
        )}

        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal">
              <div className="modal-content">
                <h3>
                  {isClassificazione
                    ? "Classifica richiesta e crea intervento"
                    : selectedIntervento
                    ? "Dettagli/Modifica Intervento"
                    : "Nuovo Intervento"}
                </h3>
                {/* <div className="modal-section">
                  <label>Cliente:</label>
                  <input type="text" value={cliente} onChange={(e) => setCliente(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Indirizzo:</label>
                  <input type="text" value={indirizzo} onChange={(e) => setIndirizzo(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Telefono:</label>
                  <input type="text" value={telefono} onChange={(e) => setTelefono(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Email:</label>
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Numero Foglio Intervento:</label>
                  <input
                    type="text"
                    value={numeroFoglioIntervento}
                    onChange={(e) => setNumeroFoglioIntervento(e.target.value)}
                    placeholder="Es. FI-001"
                  />
                </div>
                <div className="modal-section">
                  <label>Causale:</label>
                  <textarea value={causale} onChange={(e) => setCausale(e.target.value)} rows="2" />
                </div>
                <div className="modal-section">
                  <label>Tipo Intervento:</label>
                  <div className="checkbox-group">
                    {["garanzia", "manutenzione", "pagamento", "installazione", "ultimare"].map((tipo) => (
                      <label key={tipo}>
                        <input
                          type="checkbox"
                          name={tipo}
                          checked={!!tipoIntervento[tipo]}
                          onChange={handleCheckboxChange}
                        />
                        {tipo.charAt(0).toUpperCase() + tipo.slice(1)}
                      </label>
                    ))}
                  </div>
                </div>
                <div className="modal-section">
                  <label>Materiale Sostituito:</label>
                  <input
                    type="text"
                    placeholder="Materiale"
                    value={codiceMateriale}
                    onChange={(e) => setCodiceMateriale(e.target.value)}
                  />
                  <input
                    type="number"
                    step="0.1"
                    placeholder="QuantitÃ "
                    value={quantitaMateriale}
                    onChange={(e) => setQuantitaMateriale(e.target.value)}
                  />
                  <input
                    type="number"
                    placeholder="Prezzo Unitario"
                    value={prezzoUnitario}
                    onChange={(e) => setPrezzoUnitario(e.target.value)}
                  />
                  <input type="number" placeholder="Totale" value={totale} disabled />
                  <button
                    type="button"
                    onClick={materialeDaModificare ? handleUpdateMateriale : handleAddMateriale}
                    className="btn"
                  >
                    {materialeDaModificare ? "Aggiorna Materiale" : "Aggiungi Materiale"}
                  </button>
                  {materiali.length > 0 && (
                    <table className="materiali-table">
                      <thead>
                        <tr>
                          <th>Codice</th>
                          <th>QuantitÃ </th>
                          <th>Prezzo</th>
                          <th>Totale</th>
                          <th>Azioni</th>
                        </tr>
                      </thead>
                      <tbody>
                        {materiali.map((materiale) => (
                          <tr key={materiale.id}>
                            <td>{materiale.codiceMateriale}</td>
                            <td>{materiale.quantitaMateriale}</td>
                            <td>{materiale.prezzoUnitario} â‚¬</td>
                            <td>{(materiale.quantitaMateriale * materiale.prezzoUnitario).toFixed(2)} â‚¬</td>
                            <td>
                              <button onClick={() => handleEditMateriale(materiale)} className="edit-btn">
                                âœï¸
                              </button>
                              <button onClick={() => handleDeleteMateriale(materiale.id)} className="delete-btn">
                                ðŸ—‘ï¸
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="modal-section">
                  <label>Lavori Eseguiti:</label>
                  <textarea value={lavoriEseguiti} onChange={(e) => setLavoriEseguiti(e.target.value)} rows="3" />
                </div>
                <div className="modal-section">
                  <label>Tecnico:</label>
                  <input type="text" value={tecnico} onChange={(e) => setTecnico(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Data:</label>
                  <input type="date" value={data} onChange={(e) => setData(e.target.value)} />
                </div>
                <div className="modal-section time-section">
                  <div>
                    <label>Ora Inizio:</label>
                    <input
                      type="time"
                      value={oraInizio}
                      onChange={(e) => setOraInizio(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Ora Fine:</label>
                    <input
                      type="time"
                      value={oraFine}
                      onChange={(e) => setOraFine(e.target.value)}
                    />
                  </div>
                </div>
                <div className="modal-section">
                  <label>Km Percorsi:</label>
                  <input type="number" value={kmPercorsi} onChange={(e) => setKmPercorsi(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Tempo di Percorrenza:</label>
                  <input
                    type="text"
                    value={tempoPercorrenza}
                    onChange={(e) => setTempoPercorrenza(e.target.value)}
                  />
                </div>
                <div className="modal-section">
                  <label>Trasferta:</label>
                  <input type="text" value={trasferta} onChange={(e) => setTrasferta(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Stato:</label>
                  <select value={stato} onChange={(e) => handleStatoChange(e.target.value)}>
                    <option value="Da fare">Da fare</option>
                    <option value="In corso">In corso</option>
                    <option value="Completato">Chiuso</option>
                  </select>
                </div>
                <div className="modal-section">
                  <label>P.IVA:</label>
                  <input type="text" value={piva} onChange={(e) => setPiva(e.target.value)} />
                </div>
                <div className="modal-section">
                  <label>Pagato:</label>
                  <input
                    type="checkbox"
                    checked={pagato}
                    onChange={(e) => setPagato(e.target.checked)}
                  />
                </div>
                <div className="modal-section">
                  <label>Metodo di Pagamento:</label>
                  <input
                    type="text"
                    value={metodoPagamento}
                    onChange={(e) => setMetodoPagamento(e.target.value)}
                  />
                </div>
                <div className="modal-section">
                  <label>Foto/Video Principale:</label>
                  <input
                    type="file"
                    accept="image/*,video/*"
                    capture="environment"
                    onChange={handleFileChange}
                  />
                  {previewFiles.length > 0 && previewFiles[0].type.startsWith("image/") && (
                    <div className="preview-section">
                      <img src={previewFiles[0].url} alt="Preview" />
                      <button onClick={() => handleRemovePreviewFile(0)} className="btn delete-btn">
                        Cancella
                      </button>
                      <canvas
                        ref={canvasRef}
                        className="drawing-canvas"
                        onMouseDown={handleCanvasMouseDown}
                        onMouseMove={handleCanvasMouseMove}
                        onMouseUp={handleCanvasMouseUp}
                        onMouseLeave={handleCanvasMouseUp}
                      />
                    </div>
                  )}
                  {previewFiles.length > 0 && !previewFiles[0].type.startsWith("image/") && (
                    <div className="preview-section">
                      <video src={previewFiles[0].url} controls />
                      <button onClick={() => handleRemovePreviewFile(0)} className="btn delete-btn">
                        Cancella
                      </button>
                    </div>
                  )}
                </div>
                <div className="modal-section">
                  <label>Media Extra (Audio/Video/Foto):</label>
                  <input
                    type="file"
                    accept="image/*,video/*,audio/*"
                    multiple
                    onChange={handleExtraMediaChange}
                  />
                  {extraMediaPreviews.map((preview, index) => (
                    <div key={index} className="preview-section">
                      {preview.type.startsWith("image/") ? (
                        <img src={preview.url} alt={`Preview ${index}`} />
                      ) : preview.type.startsWith("video/") ? (
                        <video src={preview.url} controls />
                      ) : (
                        <audio src={preview.url} controls />
                      )}
                      <button onClick={() => handleRemoveExtraMediaPreview(index)} className="btn delete-btn">
                        Cancella
                      </button>
                    </div>
                  ))}
                </div>*/}
                <InterventoForm
  cliente={cliente}
  setCliente={setCliente}
  clienteId={clienteId}
  setClienteId={setClienteId}
  onClienteCreato={handleClienteCreatoInline}
  sitoClientePortaleId={sitoClientePortaleId}
  setSitoClientePortaleId={setSitoClientePortaleId}
  interventoId={selectedIntervento?.id || null}
  indirizzo={indirizzo}
  setIndirizzo={setIndirizzo}
  telefono={telefono}
  setTelefono={setTelefono}
  email={email}
  setEmail={setEmail}
  numeroFoglioIntervento={numeroFoglioIntervento}
  setNumeroFoglioIntervento={setNumeroFoglioIntervento}
  causale={causale}
  setCausale={setCausale}
  descrizione={descrizione}
  setDescrizione={setDescrizione}
  tipoIntervento={tipoIntervento}
  setTipoIntervento={setTipoIntervento}
  codiceMateriale={codiceMateriale}
  setCodiceMateriale={setCodiceMateriale}
  descrizioneMateriale={descrizioneMateriale}
  setDescrizioneMateriale={setDescrizioneMateriale}
  materialeCatalogoId={materialeCatalogoId}
  materialiCatalogo={materialiCatalogo}
  loadingMaterialiCatalogo={loadingMaterialiCatalogo}
  fetchMaterialiCatalogo={fetchMaterialiCatalogo}
  handleSelectMaterialeCatalogo={handleSelectMaterialeCatalogo}
  quantitaMateriale={quantitaMateriale}
  setQuantitaMateriale={setQuantitaMateriale}
  prezzoUnitario={prezzoUnitario}
  setPrezzoUnitario={setPrezzoUnitario}
  totale={totale}
  setTotale={setTotale}
  materiali={materiali}
  materialeDaModificare={materialeDaModificare}
  handleUpdateMateriale={handleUpdateMateriale}
  handleAddMateriale={handleAddMateriale}
  handleEditMateriale={handleEditMateriale}
  handleDeleteMateriale={handleDeleteMateriale}
  lavoriEseguiti={lavoriEseguiti}
  setLavoriEseguiti={setLavoriEseguiti}
  tecnico={tecnico}
  setTecnico={setTecnico}
  data={data}
  setData={setData}
  oraInizio={oraInizio}
  setOraInizio={setOraInizio}
  oraFine={oraFine}
  setOraFine={setOraFine}
  kmPercorsi={kmPercorsi}
  setKmPercorsi={setKmPercorsi}
  tempoPercorrenza={tempoPercorrenza}
  setTempoPercorrenza={setTempoPercorrenza}
  trasferta={trasferta}
  setTrasferta={setTrasferta}
  costiTrasfertaDettaglio={costiTrasfertaDettaglio}
  setCostiTrasfertaDettaglio={setCostiTrasfertaDettaglio}
  stato={stato}
  handleStatoChange={handleStatoChange}
  piva={piva}
  setPiva={setPiva}
  pagato={pagato}
  setPagato={setPagato}
  metodoPagamento={metodoPagamento}
  setMetodoPagamento={setMetodoPagamento}
  minutiPausa={minutiPausa}
  setMinutiPausa={setMinutiPausa}
  pausaInizio={pausaInizio}
  isClassificazione={isClassificazione}
  previewFiles={previewFiles}
  handleFileChange={handleFileChange}
  handleRemovePreviewFile={handleRemovePreviewFile}
  canvasRef={canvasRef}
  handleCanvasMouseDown={handleCanvasMouseDown}
  handleCanvasMouseMove={handleCanvasMouseMove}
  handleCanvasMouseUp={handleCanvasMouseUp}
  extraMediaPreviews={extraMediaPreviews}
  extraMediaFiles={extraMediaFiles}
  handleExtraMediaChange={handleExtraMediaChange}
  handleRemoveExtraMediaPreview={handleRemoveExtraMediaPreview}
/>

                <div className="modal-buttons">
                  {modalMode === "edit" && selectedIntervento && (
                    <button
                      type="button"
                      onClick={handleSaveChanges}
                      className="btn save-btn"
                    >
                      {isClassificazione
                        ? "Crea Intervento"
                        : "Salva Modifiche"}
                    </button>
                  )}
                  {modalMode === "create" && (
                    <button onClick={handleSaveChanges} className="btn save-btn">
                      Crea Intervento
                    </button>
                  )}
                  {modalMode === "view" && selectedIntervento && selectedIntervento.stato !== "Completato" && (
                    <button onClick={() => handleCloseInterventoStatus(selectedIntervento.id)} className="btn close-btn">
                      Chiudi Intervento
                    </button>
                  )}
                  <button onClick={handleCloseModal} className="btn cancel-btn">
                    Chiudi
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Dashboard;


